// Click to call (generic)
$('body').on('click', 'a[href^="tel:"]', function(e) {
  // Track event
  StepStone.trackEvent('call', 'click_to_call', 'click_to_call_general' );
});

// Click to call (header)
$('.header-call-link a[href^="tel:"]').off('click'); // Remove previous binding
$('.header-call-link a[href^="tel:"]').on('click', function(e) {
  // Track event
  StepStone.trackEvent('call', 'click_to_call', 'click_to_call_header' );
});

// Single Location Map or map link click
$('.stepstone-single-location-map-container a').on('click', function(e) {
  // Track event
  StepStone.trackEvent('click', 'single_location', 'user_clicked_view_map_' + $('body').find('h1').text().toLowerCase().trim().replace(/[\W_]+/g, '_') );
});

// Single Location click to call
$('.page-template-page-single-location .page-container a[href^="tel:"]').off('click'); // Remove previous binding
$('.page-template-page-single-location .page-container a[href^="tel:"]').on('click', function(e) {
  // Track event
  StepStone.trackEvent('call', 'single_location_click_to_call', 'single_location_click_to_call_' + $('body').find('h1').text().toLowerCase().trim().replace(/[\W_]+/g, '_') );
});